import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LogsService {
  constructor() {
    if (typeof window !== 'undefined') {
      (window as any).logs = (window as any).logs || [];
    }
  }

  static log(...args: any) {
    const timestamp = new Date().toISOString();
    const dateWithTimeFormatted = timestamp.split('T')[0] + ' ' + timestamp.split('T')[1]?.split('.')[0];
    const logEntry = { ...args, timestamp: dateWithTimeFormatted };

    if (environment.enableLogs) console.log(...args);
    if (typeof window !== 'undefined') {
      if (!(window as any)?.logs) {
        (window as any).logs = (window as any).logs || [];
      }
      (window as any).logs.push(logEntry);
    }
  }
}
